<template>
  <svg id="icon-arrow-left" width="20" height="20" viewBox="0 0 20 20">
    <g fill="none" fill-rule="evenodd">
      <path stroke="currentColor" d="M-393.5-12.5h554v512h-554z"/>
      <path d="M6.375 9.35h8.575a.55.55 0 0 1 0 1.1H6.376l2.914 2.915a.55.55 0 0 1-.78.77l-3.85-3.85a.55.55 0 0 1 0-.77l3.85-3.85a.55.55 0 0 1 .78.77L6.37 9.35h.005z" fill="currentColor" fill-rule="nonzero" stroke="currentColor"/>
    </g>
  </svg>
</template>
